import React, { useEffect, useState } from "react";
import TaskView from "../Tasks/TaskView";

const TaskInfoContainer = ({
  t,
  task,
  uncheckedTasks,
  TPNames,
  profileId,
  challengeModalVisible,
  handleNotifications,
  onCancel,
}) => {
  useEffect(() => {
    const taskFinished = task.isWorkspaceTask
      ? task.workspaceCompletionLevel >= task.quantity
      : task.completionLevel >= task.quantity;
    const index = taskFinished ? Math.ceil(Math.random() * 3) : Math.ceil(Math.random() * 5);
    const type = taskFinished ? "Finished" : "Proceeding";
    setMessageIndex(index);
    setMessageType(type);
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  const [messageIndex, setMessageIndex] = useState(0);
  const [messageType, setMessageType] = useState("");
  return (
    <>
      {task.completionLevel < task.quantity && (
        <div className="notification-check-box">
          <input
            type="checkbox"
            id="sendNotifications"
            onChange={() => handleNotifications(task._id)}
            checked={!uncheckedTasks.has(task._id)}
          />
          <label className={`${!uncheckedTasks.has(task._id) && "checked"}`} htmlFor="sendNotifications"></label>
          <span>{t("challengeModal.CheckboxLabel")}</span>
        </div>
      )}
      <div
        className="challenge-message"
        dangerouslySetInnerHTML={{ __html: t(`challengeModal.Challenge${messageType}Message${messageIndex}`) }}
      ></div>
      <TaskView
        key={task._id}
        task={task}
        ended={false}
        profileId={profileId}
        isFullscreen={false}
        TPNames={TPNames}
        modalVisible={challengeModalVisible}
        closeModal={onCancel}
      />
    </>
  );
};

export default TaskInfoContainer;
